module.exports = __webpack_public_path__ + "img/kt-kg.4a06a999.png";